import { EMPTY_MOVEMENT_PATTERN_DTL_ENTITY, MovementPatternDtlEntity } from "domain/entity/MovementPattern/MovementPatternDtlEntity";
import { EMPTY_MOVEMENT_PATTERN_ENTITY, MovementPatternEntity } from "domain/entity/MovementPattern/MovementPatternEntity";
import { BaseViewChangeSate } from "../BaseViewChangeState";
import { DropdownProps } from "../DropdownProps";

export interface MovementPatternDropdownOptions {
    moveIndDropdownOptions: DropdownProps[],
    companyCodeDropdownOptions: DropdownProps[],
}
export interface MovementPatternViewChangeState extends BaseViewChangeSate {
}

export interface MovementPatternModel {
    isLoading: boolean,
    isShowEditPanel: boolean,
    isAdd: boolean,
    isEdit: boolean,
    isShowDtlEditPanel: boolean,
    isShowDtlAddPanel: boolean,
    dynamicOptions: MovementPatternDropdownOptions,
    movementPatternList: MovementPatternEntity[],
    selectedRows: MovementPatternEntity[],
    updatedRows: MovementPatternEntity[],
    currentRow: MovementPatternEntity,
    currentEditRow: MovementPatternEntity,
    currentDtlEditRow: MovementPatternDtlEntity,
    selectedDtlRows: MovementPatternDtlEntity[],
    tempDtlRows: MovementPatternDtlEntity[],
    forceRefresh: boolean,
    dtlForceRefresh: boolean,
    masterState: MovementPatternViewChangeState,

}

export const EMPTY_MOVEMENT_PATTERN_MODEL: MovementPatternModel = {
    isLoading: false,
    isShowEditPanel: false,
    isAdd: false,
    isEdit: false,
    isShowDtlEditPanel: false,
    isShowDtlAddPanel: false,
    dynamicOptions: {
        companyCodeDropdownOptions: [],
        moveIndDropdownOptions: []
    },
    movementPatternList: [],
    selectedRows: [],
    updatedRows: [],
    currentRow: { ...EMPTY_MOVEMENT_PATTERN_ENTITY },
    currentEditRow: { ...EMPTY_MOVEMENT_PATTERN_ENTITY },
    currentDtlEditRow: { ...EMPTY_MOVEMENT_PATTERN_DTL_ENTITY },
    selectedDtlRows: [],
    tempDtlRows: [],
    forceRefresh: false,
    dtlForceRefresh: false,
    masterState: {
        isSliderOpen: false,
        isTabularDataActive: false,
        isAdd: false,
        isRead: false,
        isEditable: false,
        isSaveClicked: false,
        lastEditRowId: "",
        isSelected: false,
        slider: {
            isAdd: false,
            isRead: false,
            isEditable: false
        }
    }
}